import React from "react";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Typography, TextField, Button } from "@material-ui/core";
import { updateProfileSettings } from "../../../../store/user-preferences/actions";
import useStyles from "./styles";

const EditProfile = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [edit, toggleEdit] = useState(false);
  const username = useSelector((state) => state.userPreferences.username);
  const displayName = useSelector((state) => state.userPreferences.displayName);
  const email = useSelector((state) => state.userPreferences.email);
  const [newName, setNewName] = useState(displayName);
  const [newUsername, setNewUsername] = useState(username);
  const [newEmail, setNewEmail] = useState(email);
  const [focus, setFocus] = useState("");

  const handleClick = () => {
    if (!edit) {
      toggleEdit(true);
    }
  };

  const handleUpdate = () => {
    if (!edit) {
      toggleEdit(!edit);
      return;
    }
    if (newName && newUsername && newEmail) {
      toggleEdit(false);
      dispatch(
        updateProfileSettings({
          username: newUsername,
          displayName: newName,
          email: newEmail,
        })
      );
    }
  };

  const EditForm = () => (
    <>
      <Typography className={classes.label}>Name: </Typography>
      <TextField
        inputRef={(input) => focus === "name" && input && input.focus()}
        variant={edit ? "outlined" : "filled"}
        placeholder="Enter your name"
        defaultValue={newName}
        disabled={!edit}
        error={!newName}
        required
        onChange={(event) => setNewName(event.target.value)}
        onClick={() => {
          handleClick();
          setFocus("name");
        }}
      />
      <Typography className={classes.label}>Username: </Typography>
      <TextField
        inputRef={(input) => focus === "username" && input && input.focus()}
        variant={edit ? "outlined" : "filled"}
        placeholder="Enter a username"
        defaultValue={newUsername}
        disabled={!edit}
        error={!newUsername}
        required
        onChange={(event) => setNewUsername(event.target.value)}
        onClick={() => {
          handleClick();
          setFocus("username");
        }}
      />
      <Typography className={classes.label}>Email: </Typography>
      <TextField
        inputRef={(input) => focus === "email" && input && input.focus()}
        variant={edit ? "outlined" : "filled"}
        placeholder="Enter your email"
        defaultValue={newEmail}
        disabled={!edit}
        error={!newEmail}
        required
        onChange={(event) => setNewEmail(event.target.value)}
        onClick={() => {
          handleClick();
          setFocus("email");
        }}
      />
      <div className={classes.buttonGroup}>
        <Button variant="outlined" color="primary" className={classes.password}>
          Change Password
        </Button>
        <Button className={classes.delete}>Delete Account</Button>
      </div>
      <div className={classes.updateDiv}>
        <Button
          className={classes.update}
          variant="contained"
          color="primary"
          onClick={handleUpdate}
        >
          Update
        </Button>
      </div>
    </>
  );

  return (
    <div className={classes.root}>
      <Typography className={classes.header}>Profile Settings</Typography>
      <EditForm />
    </div>
  );
};

export default EditProfile;
